import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoStaffsGetRes } from "./abst/DtoStaffsGetRes";

export class DtoStaffsGetResImple extends DtoStaffsGetRes {
  public pager = new DtoApiPager();
}
